export const HOME_USER_DIALOG = {
  GO_TO_MEMBERSHIP_PAGE: 'GO_TO_MEMBERSHIP_PAGE',
  GO_TO_COURSE_AGENDA: 'GO_TO_COURSE_AGENDA',
  CLOSE_COURSE_AGENDA: 'CLOSE_COURSE_AGENDA',
  ENGLISH_PREMIUM_COURSE_ACCEPTED: 'ENGLISH_PREMIUM_COURSE_ACCEPTED',
  ENGLISH_PREMIUM_COURSE_DECLINED: 'ENGLISH_PREMIUM_COURSE_DECLINED',
  ENGLISH_PREMIUM_DIALOG_CLOSED: 'ENGLISH_PREMIUM_DIALOG_CLOSED',
};

export const AFTER_PURCHASE_AD_MOUNTED = 'AFTER_PURCHASE_AD_MOUNTED';

export const AFTER_PURCHASE_AD_CLICKED = 'AFTER_PURCHASE_AD_CLICKED';

export const AFTER_PURCHASE_AD_CLOSED = 'AFTER_PURCHASE_AD_CLOSED';

// My Courses
export const CLICK_COURSE = 'click_homeuser_course';
export const FILTER_COURSE = 'filter_homeuser_course';
export const GO_TO_PANEL = 'go_to_panel_homeuser';
export const CLICK_RECOMMENDED_COURSE = 'click_homeuser_recommended';
export const GO_TO_CATALOG = 'go_to_catalog_homeuser';

// FREE COURSES CAMPAIGN SECTION
export const CLICK_FREE_COURSES_CAMPAIGN_LINK =
  'Click free courses campaign link';

// Crehana Live
export const GO_TO_LIVE_DETAIL = 'Go to live detail from homeuser';
export const GO_TO_LIVE_DETAIL_B2B = 'Go to live detail from homeuser b2b';
export const GO_TO_LIVE_LANDING = 'Go to live landing from homeuser';
export const GO_TO_LIVE_LANDING_B2B = 'Go to live landing from homeuser b2b';

// User tastes
export const EDIT_USER_TASTES = 'Edit user tastes from homeuser';

// Tracks
export const GO_TO_TRACK_DETAIL = 'Go to track detail from homeuser';

// Premium CTA
export const GO_TO_MEMBERSHIP_LANDING =
  'Go to membership landing from homeuser';

export const OPEN_TEMPORAL_ACCESS_SNACK_BAR =
'Open temporal access snack bar in homeuser';
